import React from 'react'
import { connect } from 'react-redux'
import GameModal from '../components/game-modal'

const mapStateToProps = (state) => ({
  ...state.gameModal
})

const mapDispatchToProps = dispatch => ({
  loadGame: payload => dispatch({type: 'GAME_MODAL.LOAD_GAME', payload}),
  clearGame: payload => dispatch({type: 'GAME_MODAL.CLEAR_GAME', payload}),
  showAlert: payload => dispatch({type: 'GAME_MODAL.SHOW_ALERT', payload}),
  clearAlert: payload => dispatch({type: 'GAME_MODAL.CLEAR_ALERT', payload}),
  onEditCost: payload => dispatch({type: 'GAME_MODAL.EDIT_COST', payload}),
  onConfirm: payload => dispatch({type: 'GAME_MODAL.CONFIRM', payload}),
  onNoShow: payload => dispatch({type: 'GAME_MODAL.NO_SHOW', payload}),
  onAddPlayer: payload => dispatch({type: 'GAME_MODAL.ADD_PLAYER', payload}),
  onPlayersCount: payload => dispatch({type: 'GAME_MODAL.CHANGE_PLAYERS_COUNT', payload}),
  onRenamePlayer: payload => dispatch({type: 'GAME_MODAL.RENAME_PLAYER', payload}),
  onEditPlayerCost: payload => dispatch({type: 'GAME_MODAL.EDIT_PLAYER_COST', payload}),
  onDeletePlayer: payload => dispatch({type: 'GAME_MODAL.DELETE_PLAYER', payload}),
  onUpdatePlayer: payload => dispatch({type: 'GAME_MODAL.UPDATE_PLAYER', payload}),
  onRefundPaidFor: payload => dispatch({type: 'GAME_MODAL.REFUND_PAIDFOR', payload}),
  onStartRefund: payload => dispatch({type: 'GAME_MODAL.START_REFUND', payload}),
  onCancelRefund: payload => dispatch({type: 'GAME_MODAL.CANCEL_REFUND', payload}),
  onRefundPayment: payload => dispatch({type: 'GAME_MODAL.REFUND_PAYMENT', payload}),
  onRefundReceipt: payload => dispatch({type: 'GAME_MODAL.REFUND_RECEIPT', payload}),
  onStartPayment: payload => dispatch({type: 'GAME_MODAL.START_PAYMENT', payload}),
  onClearPayment: payload => dispatch({type: 'GAME_MODAL.CLEAR_PAYMENT', payload}),
  onCreateNote: payload => dispatch({type: 'GAME_MODAL.CREATE_NOTE', payload}),
  onEditNote: payload => dispatch({type: 'GAME_MODAL.EDIT_NOTE', payload}),
  onRemoveNote: payload => dispatch({type: 'GAME_MODAL.REMOVE_NOTE', payload}),
  onUpdateGame: payload => dispatch({type: 'GAME_MODAL.UPDATE_GAME', payload}),
  onChangeReservation: payload => dispatch({type: 'GAME_MODAL.CHANGE_RESERVATION', payload}),
  onCloseCalendar: payload => dispatch({type: 'GAME_MODAL.CLOSE_CALENDAR', payload}),
  onPaymentLinked: payload => dispatch({type: 'GAME_MODAL.PAYMENT_LINKED', payload}),
  onLoadEvents: payload => dispatch({type: 'GAME_MODAL.LOAD_EVENTS', payload}),
  onLoadNotes: payload => dispatch({type: 'GAME_MODAL.LOAD_NOTES', payload}),
})

export default connect(mapStateToProps, mapDispatchToProps)(GameModal)
